export const ToggleListV2 = {
    template: //html
    `
      <div class="relative toggle-list-section ">

        <div @click.stop="display" class=" w-full px-3 flex h-12 content-between border border-secondary cursor-pointer   toggle-list-box">

          <div class=" w-full  h-full flex justify-start items-center font-bold text-xl toggle-list-title">
            {{name}}
          </div>

          <div v-if="!show"  class="h-full bg-white flex justify-center items-center  toggle-list-icon-off">
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.99709 6L0 0.857143L0.832849 0L4.99997 4.28868L9.16709 0L9.99994 0.857143L5.00285 6L4.99997 5.99704L4.99709 6Z" fill="#414042"/>
            </svg>          
          </div>
          <div v-else  class="h-full flex justify-center items-center bg-white  toggle-list-icon-on" style="background-color:#FFF;" >
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.99709 0L0 5.14286L0.832849 6L4.99997 1.71132L9.16709 6L9.99994 5.14286L5.00285 0L4.99997 0.0029645L4.99709 0Z" fill="#414042"/>
            </svg>          
          </div>
        </div>

        <ul v-if="show" class="absolute py-5 flex flex-col gap-y-2 border border-t-0 border-secondary w-full z-20 bg-white toggle-list-content" style="margin-top:unset;">

          <li v-for="(item, index) in items" :key="index" class=" text-base ml-5 text-dark item" style="font-size:1rem;line-height:1.25rem">
            {{item}}
          </li>

        </ul>
      </div>
    `,
    props: [
      'name', 
      'items'
    ],
    data() {
      return {
        show: false,
        theme_directory: window.theme_directory,
      }
    },
    mounted() {
      this.$parent.$on('closeAllExcept', (who) => {
        if(this.name != who)
          this.show = false;
      })
    },
    methods: {
      display(){
        this.show = !this.show;
        if(this.show)
          this.$emit('toggleopened', this.name);
      },
    },
  }
  